import { __assign } from "tslib";
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { Lead } from 'models';
import CUSTOMER_PROFILE_SCHEMA from 'models/schemas/customerProfile.schema';
import CustomerProfileSections from './CustomerProfileSections';
var newLead = new Lead();
var CustomerProfile = function (_a) {
    var lmktId = _a.lmktId, hasFilter = _a.hasFilter, getCustomerData = _a.getCustomerData, onFilter = _a.onFilter;
    var formMethods = useForm({
        defaultValues: newLead,
        delayError: 500,
        mode: 'onChange',
        resolver: CUSTOMER_PROFILE_SCHEMA,
        shouldFocusError: false
    });
    return (React.createElement(FormProvider
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign({}, formMethods),
        React.createElement(Grid, { container: true, noValidate: true, component: "form" },
            React.createElement(CustomerProfileSections, { getCustomerData: getCustomerData, hasFilter: hasFilter, lmktId: lmktId, onFilter: onFilter }))));
};
export default CustomerProfile;
//# sourceMappingURL=CustomerProfile.js.map